module.exports = __webpack_public_path__ + "img/client-4.7ad81859.png";